// extracted by mini-css-extract-plugin
export var dropdownButton = "_26-0";
export var fullWidthDropdownButton = "_26-1";
export var icon = "_26-3";
export var iconPlaceholder = "_26-2";
export var menuItemRow = "_26-8";
export var separator = "_26-d";
export var shortcutContainer = "_26-7";
export var shortcutIconLg = "_26-6";
export var shortcutIconMd = "_26-5";
export var shortcutIconSm = "_26-4";
export var submenuChevron = "_26-c";
export var submenuDropdown = "_26-9";
export var submenuTriggerRow = "_26-a";
export var submenuTriggerRowOpen = "_26-b";